import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let { id: insured_id } = useDataValue({
    context: 'assigned_insurance',
    viewPath: props.viewPath,
  })
  return {
    variables: {
      insured_id,
    },
  }
}
